/**
 * @class
 * @description This class connect to cdn the cdb balancer api and hepls to get data
 * @exports BandwithLimiterBusinessObject
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import Utils from '../Utils/Utils';
export default class BandwithLimiterBusinessObject {
    limit(maxBandwith, segment) {
        return __awaiter(this, void 0, void 0, function* () {
            let bandwidth = segment.size / (segment.downloadTimeMs / 1000) * 8;
            if (maxBandwith != 0 && bandwidth > maxBandwith) {
                let targetDonwloadTime = (1000 * segment.size * 8) / maxBandwith;
                let currentDownlaodTime = Date.now() - segment.startTime;
                let missingTime = targetDonwloadTime - segment.downloadTimeMs;
                if (missingTime > 0) {
                    yield Utils.delay(missingTime);
                }
                segment.endTime = Date.now();
                segment.downloadTimeMs = segment.endTime - segment.startTime;
                segment.bandwidth = segment.size / (segment.downloadTimeMs / 1000);
                segment.instantBandwidth = 0;
                segment.progressDownloadedBytesLastUpdate = segment.endTime;
            }
        });
    }
}
